// *******************************************************************************
// 1.0 - Range Slider
// *******************************************************************************
const rangeSliderElem = document.querySelectorAll('#range-slider-input');

rangeSliderElem.forEach((el) => {
  const rangeFrom = el.getAttribute('data-from');
  const rangeTo = el.getAttribute('data-to');
  const rangeMinNum = parseInt(el.getAttribute('data-min'), 10);
  const rangeMaxNum = parseInt(el.getAttribute('data-max'), 10);

  const parentEle = el.closest('.range-slider');
  const rangeStartInput = parentEle.querySelector('.range-slider__start-range input');
  const rangeEndInput = parentEle.querySelector('.range-slider__end-range input');

  const rangeValues = [rangeStartInput, rangeEndInput];

  noUiSlider.create(el, {
    start: [rangeFrom, rangeTo],
    connect: true,
    range: {
      min: rangeMinNum,
      max: rangeMaxNum,
    },
    tooltips: false,
    format: wNumb({
      mark: ',',
      decimals: 2,
    }),
  });

  el.noUiSlider.on('update', (values, handle) => {
    rangeValues[handle].value = values[handle];
  });
});
